define(function (require) {
  'use strict';

  var _ = require('underscore');
  var Marionette = require('marionette');
  var TemplatesModel = require('models/messageTemplate');
  var BodyTPL = require('text!modals/email_edit/body.tpl').default;
  var Config = require('config/application');
  var IntegratedEmails    = require('collections/integratedEmails');

  return Marionette.ItemView.extend({
    template: BodyTPL,
    className: 'b-popover__email_edit-body',

    ui: {
      domain: '.js-email-domain',
      username: '.js-email-user',
      textarea: '.b-popover__email_edit-text',
      templateSelect: '.js-email-template',
      addTemplateBtn: '.js-add-tpl'
    },

    events: {
      'change @ui.domain': 'changeDomain',
      'keyup @ui.username': 'changeUsername',
      'change @ui.templateSelect': 'onSelectTemplate',
      'click @ui.addTemplateBtn': 'onClickAddTemplate'
    },

    initialize: function (options) {
      this.options = options

      options = options || {};
      this.emailList = [];
      var list = [];
      /** add domains to list */
      options.domains.forEach(function(el) {
        list.push({
          id: el.id,
          type: 'txt',
          domain: el.domain,
          username: '',
          editable: true,
        });
      });

      /** add emails to list */
      options.emails.forEach(function(el) {
        list.push({
          id: el.id,
          type: el.type,
          domain: el.email.split('@')[1],
          username: el.email.split('@')[0],
          editable: false,
        });
      });

      this.emailList = list;
      this.templates = options.templates;

      this.listenTo(this.model, 'invalid', this.onInvalid);
      this.listenTo(this.model, 'change:template_id', this.onChangeTemplateId);
      this.listenTo(this.model, 'change:subject change:text', this.onChangeText);
    },

    changeDomain: function () {
      var id = this.ui.domain.val();
      var domain = this.emailList.find(function(el) { return (el.id == id)} );

      this.ui.username.val(domain.username);

      if (!domain.editable) {
        this.ui.username.attr('readonly', 'readonly');
      }
      else {
        this.ui.username.removeAttr('readonly');
      }

      this.model.set('from',
        (domain.username) ? domain.username : 'noreply'
          + '@' + domain.domain
      );
      app.storage.write('lastEmailDomain', id)
    },

    changeUsername: function () {
      var username = (this.ui.username.val() || '').toLowerCase().replace(new RegExp('[^a-z0-9.-_]', 'g'), '');

      var domain_id = this.ui.domain.val();
      var domain = this.emailList.find(function(el) { return el.id == domain_id;});

      this.ui.username.val(username);
      username = username || 'noreply';
      this.model.set('from', username + '@' + domain.domain);
      app.storage.write('lastEmailUsername', username != 'noreply' ? username:'')
    },

    onSelectTemplate: function () {
      var templateId = this.ui.templateSelect.val();
      var template = templateId && this.templates.get(templateId);

      if (template) {
        this.model.set({
          subject: template.get('template_subject'),
          text: template.get('template_text'),
          template_id: templateId
        });
      }
    },

    createSelect: function () {
      var that = this;
      var templateId = this.model.get('template_id');

      this.ui.templateSelect.select2({
        dropdownParent: that.$el,
        allowClear: true,
        placeholder: {
          id: '',
          text: "Название шаблона",
          selected: 'selected'
        },
        // data: [{ id: '', text: '', selected: 'selected', search: '', hidden: true }].concat(this.templates.toJSON()),
        escapeMarkup: function (markup) {
          return markup;
        },
        language: {
          noResults: function () {
            var query = that.$('.select2-search__field').val();

            return '<a href="javascript:void(0);" class="js-add-tpl">' + query + ' (создать новый шаблон)</a>';
          }
      },
      templateResult: function(state) {
          if (!state.id && !state.value){
              return state.text;
          }
          var html = '<span>';
            html += state.text;
            html += '<i style="float:right" class="js-delete-template fa fa-times" data-id="' + state.id + '"></i>';
            html += '</span>';

          var $state = $(html);
          return $state;
      }
      });
      this.ui.templateSelect.off('select2:selecting');
      this.ui.templateSelect.on('select2:selecting', function(event) {
              var args = event.params.args;
              var id;
              if ($(args.originalEvent.target).hasClass('js-delete-template')) {
                  var cid = $(args.originalEvent.target).data('id');
                  that.deleteTemplate(cid);
                  return false;
              }
          });
      if (templateId) {
        this.ui.templateSelect.val(templateId).trigger('change');
      }
    },

    deleteTemplate: function(cid)
    {
        var that = this;
        var template = this.templates.get(cid);
        var templateId = template.get('id');
        if(templateId){
            Backbone.ajax({
                url: Config.host + '/rest/templates/' + templateId,
                dataType: 'JSON',
                type: 'DELETE',
                success: function (response) {
                    app.message.success('Шаблон удален');
                    that.templates.remove(cid);
                    that.render();
                },
                error: function (xhr) {
                    app.message.success('Ошибка удаления шаблона');
                }
            });
        }else{
            that.templates.remove(cid);
            that.render();
        }
    },

    onClickAddTemplate: function () {
      var name = this.$('.select2-search__field').val();
      var model = new TemplatesModel({
        template_name: name,
        template_subject: this.model.get('subject'),
        template_text: this.model.get('text'),
        type: 1,
      });
      //
      //if (!this.model.get('subject') || !this.model.get('text')) {
      //    app.message.error('Заполните тему и текст сообщения');
      //    return;
      //}

      //model
      //    .save()
      //    .then(function() {
      this.templates.add(model);
      this.model.set('template_id', model.cid);
      this.render();
      //app.message.success('Шаблон сохранен');
      //}.bind(this))
      //.fail(function(xhr) {
      //    var message = xhr.responseJSON && xhr.responseJSON.message || 'Не удалось сохранить шаблон';
      //    app.message.error(message);
      //})
    },

    onRender: function () {
      this.fillEmail();
      app.Rivets.bind(this.el, { model: this.model });
      this.createSelect();
    },

    fillEmail: function() {
      let changeState = () => {
        var email = this.emailList.find((el) => {
          return (el.id == this.domain)
        });
        if (email && email.username) {
          this.username = email.username;
        }

        if (email && !email.editable) {
          this.ui.username.attr('readonly', 'readonly');
        } else {
          this.ui.username.removeAttr('readonly');
        }

        this.ui.username.val(this.username);
        this.ui.domain.val(this.domain)

        this.model.set('from', email ? `${this.username}@${email.domain}` : '');
      }

      let validEmailDomains = _.reject(this.emailList, {id: -1});
      if (validEmailDomains.length <= 0) {
        this.domain = -1;
        changeState()
      } else {
        let latestDomain = _.last(_.sortBy(validEmailDomains, 'id'));

        let intergratedEmails = new IntegratedEmails();
        intergratedEmails
            .fetch()
            .then(() => {
              let validEmails = _.filter(intergratedEmails.toJSON(), (item) => {
                return item.id > 0
              });

              emailsLoop:
              for (let email of validEmails) {
                for (let domain of validEmailDomains) {
                  if (email.email.indexOf(domain.domain) > -1) {

                    if(!this.domain && app.storage.read('lastEmailDomain')) {
                      this.domain = app.storage.read('lastEmailDomain')
                    } else {
                      this.domain = domain.id;
                    }

                    if (!this.username && app.storage.read('lastEmailUsername')) {
                      this.username = app.storage.read('lastEmailUsername')
                    } else {
                      let emailParts = email.email.split('@')
                      this.username = emailParts[0];
                    }

                    break emailsLoop;
                  }
                }
              }

              if (!this.domain) {
                this.domain = app.storage.read('lastEmailDomain')
              }

              if (!this.domain) {
                this.domain = latestDomain.id

                if (!this.username && app.storage.read('lastEmailUsername')) {
                  this.username = app.storage.read('lastEmailUsername')
                }

                if (!this.username) {
                  this.username = 'noreply'
                }
              }

              changeState()
            });
      }
    },

    serializeData: function () {
      var templates = [];

      this.templates.each(function (template) {
        var obj = template.toJSON();

        obj.cid = template.cid;
        templates.push(obj);
      });

      /** Init state */
      var username = (this.emailList[0]) ? this.emailList[0].username : '';
      var usernameReadonly = (this.emailList[0]) ? !this.emailList[0].editable : false;

      console.log(username, this.emailList,)

      return {
        username: username,
        usernameReadonly: usernameReadonly,
        modal: this.model.toJSON(),
        emails: this.emailList,
        templates: templates,
      }
    },

    onChangeText: function () {
      if (this.model.get('template_id')) {
        this.trigger('toggleAddTemplateBtn', true);
      }
    },

    onChangeTemplateId: function (model, value) {
      if (value) {
        this.trigger('toggleAddTemplateBtn', this.templates.get(value).isNew());
      }
    },

    onInvalid: function (model, errors) {
      var that = this;
      var message = '';
      this.$('.js-subject').removeClass('error-control');
      this.$('.js-text').removeClass('error-control');
      _.each(errors, function (error, i) {
        if (i > 0) {
          message += '<br/>';
        }
        message += error.message;
        that.$('.js-' + error.field).addClass('error-control');
      });
      app.message.error(message);
    }
  });
});
